import React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Define the possible sizes for the heading
const sizeStyles = {
  small: {
    fontSize: { xs: "0.75rem", sm: "0.85rem", md: "1rem", lg: "1rem" },
    fontWeight: 400,
  },
  medium: {
    fontSize: { xs: "0.75rem", sm: "0.85rem", md: "1rem", lg: "1.2rem" },
    fontWeight: 400,
  },
  large: {
    fontSize: { xs: "0.75rem", sm: "0.85rem", md: "1rem", lg: "1.25rem" },
    fontWeight: 400,
  },
};

const PrimaryDesc = ({ size = "medium", variant = "h1", children }) => {
  const theme = useTheme();

  return (
    <Typography
      className="whitespace-pre-line text-primary"
      sx={{
        ...sizeStyles[size], // Apply the size styles based on the prop
      }}
    >
      {children}
    </Typography>
  );
};

export default PrimaryDesc;

// PrimaryDesc.prototypes = {
//   size: PropTypes.oneOf(["small", "medium", "large"]),
//   variant: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
//   children: PropTypes.node.isRequired,
// };
